/*
 * KINESA · Mobile swipe intro v3
 * First vertical swipes advance the gallery one image at a time until image 3,
 * then normal page scroll resumes.
 *
 * v3: NO body position lock or overflow lock. Just preventDefault on touchmove/
 *     wheel events globally while locked. DOM and layout stay untouched so the
 *     gallery's lazy-load IntersectionObserver fires normally and the first
 *     paint shows images correctly.
 */
(function () {
  if (window.__knMobileSwipeIntroInit) return;
  window.__knMobileSwipeIntroInit = true;

  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;

  var TARGET_INDEX = 2; // 0-indexed: showing image 3 == release
  var SWIPE_THRESHOLD = 24;
  var SWIPE_DEBOUNCE_MS = 280;
  var SAFETY_RELEASE_MS = 18000;

  var locked = false;
  var lastY = null;
  var lastX = null;
  var gestureAxis = null; // 'v' once decided vertical, 'h' once decided horizontal
  var lastSwipeTime = 0;
  var thumbs = [];
  var observer = null;

  function getCurrentIndex() {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].getAttribute('aria-selected') === 'true') return i;
    }
    return 0;
  }

  function advance() {
    var now = Date.now();
    if (now - lastSwipeTime < SWIPE_DEBOUNCE_MS) return;
    lastSwipeTime = now;
    var nextIdx = getCurrentIndex() + 1;
    if (nextIdx <= TARGET_INDEX && thumbs[nextIdx]) {
      thumbs[nextIdx].click();
    }
  }

  function checkRelease() {
    if (getCurrentIndex() >= TARGET_INDEX) release();
  }

  function shouldIgnoreTouch(target) {
    if (!target || !target.closest) return false;
    return !!(
      target.closest('a') ||
      target.closest('button') ||
      target.closest('input') ||
      target.closest('select') ||
      target.closest('textarea')
    );
  }

  function onTouchStart(e) {
    if (!locked) return;
    lastY = e.touches[0].clientY;
    lastX = e.touches[0].clientX;
    gestureAxis = null;
  }

  function onTouchMove(e) {
    if (!locked || lastY === null || lastX === null) return;
    if (shouldIgnoreTouch(e.target)) return;
    var dy = lastY - e.touches[0].clientY;
    var dx = lastX - e.touches[0].clientX;

    // Decide gesture axis on first meaningful movement and stick with it.
    if (gestureAxis === null) {
      if (Math.abs(dy) > 6 || Math.abs(dx) > 6) {
        gestureAxis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      }
    }

    // Horizontal gesture: let it pass through to the native Horizon slideshow / thumb strip
    if (gestureAxis === 'h') return;

    // Vertical gesture: block page scroll and advance gallery on each downward swipe
    if (e.cancelable) e.preventDefault();
    if (Math.abs(dy) >= SWIPE_THRESHOLD) {
      if (dy > 0) advance();
      lastY = e.touches[0].clientY;
      lastX = e.touches[0].clientX;
    }
  }

  function onWheel(e) {
    if (!locked) return;
    if (e.cancelable) e.preventDefault();
    if (e.deltaY > 6) advance();
  }

  function onScroll() {
    if (!locked) return;
    if (window.scrollY > 4) window.scrollTo(0, 0);
  }

  function release() {
    if (!locked) return;
    locked = false;
    document.removeEventListener('touchstart', onTouchStart, { capture: true });
    document.removeEventListener('touchmove', onTouchMove, { capture: true });
    document.removeEventListener('wheel', onWheel, { capture: true });
    window.removeEventListener('scroll', onScroll);
    if (observer) observer.disconnect();
  }

  function startLock() {
    if (window.scrollY > 80) return;
    locked = true;

    document.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
    document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
    document.addEventListener('wheel', onWheel, { passive: false, capture: true });
    window.addEventListener('scroll', onScroll, { passive: true });

    observer = new MutationObserver(checkRelease);
    thumbs.forEach(function (t) {
      observer.observe(t, { attributes: true, attributeFilter: ['aria-selected'] });
    });

    setTimeout(function () { if (locked) release(); }, SAFETY_RELEASE_MS);
  }

  function waitForFirstImage(cb) {
    var imgs = document.querySelectorAll('media-gallery img');
    if (!imgs.length) { cb(); return; }
    var first = imgs[0];
    if (first.complete && first.naturalWidth > 0) { cb(); return; }
    first.addEventListener('load', function () { setTimeout(cb, 60); }, { once: true });
    first.addEventListener('error', function () { cb(); }, { once: true });
    // Safety timeout — start anyway after 1.5s even if load event doesn't fire
    setTimeout(cb, 1500);
  }

  function tryInit(attempts) {
    attempts = attempts || 0;
    if (attempts > 30) return; // ~6s give-up

    thumbs = document.querySelectorAll('media-gallery .slideshow-controls__thumbnail');
    if (thumbs.length < 3) {
      setTimeout(function () { tryInit(attempts + 1); }, 200);
      return;
    }

    waitForFirstImage(startLock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tryInit(0); });
  } else {
    tryInit(0);
  }
})();
